import React, { Component } from "react";
import { View, Image, TouchableOpacity, FlatList,ScrollView} from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, customerLocationStyles, componentStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import Button from "../components/Button";
import { blueDarkColor, blueLightColor, greenDarkColor, greenLightColor } from "../theme/colors";
import { getNeedInfoRequest, favoritPersonsRequest, completeOrderRequest } from "../utils/api";
import Waiting from "../components/Waiting";
import DialogPrompt from "../components/DialogPrompt";
import * as ImagePicker from 'expo-image-picker';
import { showMessage, getError, showMessageCallback } from "../utils/utils";
import { wp} from "../utils/responsive";
import TextInput from "../components/TextInput/TextInput";
import BottomModal from "../components/BottomModal";
import DialogFavExper from "../components/DialogFavExper";
const regexnonenglishdigit = /[a-z]|[A-Z]|[0-9]|[۱۲۳۴۵۶۷۸۹۰]/g;

export default class CompleteOrderScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            favorits: [],
            selectedExpert: null,
            showQuestion: false,
            choseImage: false,
            showPrompt: false,
            promptMessage: '',
            name: '',
            gender: 0,
            code_meli: '',
            phone: '',
            mobile: '',
            bime: '',
            rebateCode: '',
            isequipment: 0,
            textfield: '',
            selectedPerson: null,
            waiting: true,
            needInfo: null
        }
        this.inputs = {};
    }
    _keyExtractor = (item, index) => index.toString();
    renderFavoritRow({ item, index }) {
        return <TouchableOpacity style={componentStyles.favoritItem} activeOpacity={0.5} onPress={() => {
            this.setState({
                selectedPerson: item,
                mobile: item.cellphone,
                code_meli: item.codemeli,
                name: item.flname,
                phone: item.phone,
                gender: item.sex.includes('female') ? 1 : 0
            })
        }}>
            <TextView>{item.flname}</TextView>
            <Image source={icons['avatar']} style={componentStyles.favoritIcon} />
        </TouchableOpacity>
    }
    takeImage() {
        ImagePicker.launchCameraAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.Images,
            allowsEditing: true,
            aspect: [4, 4],
            base64: true,
            quality: 0.8,
        }).then(image => {
            this.setState({
                textfield: image
            })
        }).catch(error => {
            if (__DEV__) console.log(error)
        });

    }
    pickImage() {
        ImagePicker.launchImageLibraryAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.Images,
            allowsEditing: true,
            aspect: [4, 4],
            base64: true,
            quality: 0.8,
        }).then(image => {
            this.setState({
                textfield: image
            })
        }).catch(error => {
            if (__DEV__) console.log(error)
        });
    }
    focusTheField = (prev, next) => {
        this.inputs[prev].blur()

        this.inputs[next].focus();
    }
    render() {
        return (
            <ScrollView contentContainerStyle={[{ width: wp(100) }, appStyles.center]} enableOnAndroid={true} keyboardShouldPersistTaps='handled'>
                <View style={{ flex: 1 }} >
                    <View style={appStyles.toolbarWraper}>
                        <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                        <TextView style={appStyles.toolbarTitle}>اطلاعات مددجو</TextView>
                        <TouchableOpacity onPress={() => {
                            this.props.navigation.goBack()
                        }}>
                            <Image source={icons['back']} style={appStyles.backIcon} />
                        </TouchableOpacity>
                    </View>


                    {this.state.selectedPerson == null ? <View style={{ height: 50, margin: 10 }}>
                        <FlatList
                            data={this.state.favorits}
                            renderItem={this.renderFavoritRow.bind(this)}
                            keyExtractor={this._keyExtractor}
                            inverted={true}
                            horizontal={true}
                        />
                    </View> : null}
                    <LinearGradient colors={this.state.selectedPerson == null ? [blueDarkColor, blueLightColor] : [greenDarkColor, greenLightColor]}
                        style={[this.state.selectedPerson == null ? appStyles.completeOrderwraper : appStyles.completeLongOrderwraper]}>
                        <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                            {this.state.needInfo != null && this.state.needInfo.orderdetails_need != null
                                && this.state.needInfo.orderdetails_need.length > 0 ? <View>
                                    {this.state.needInfo.orderdetails_need[0].typefield.includes('image') ?
                                        <View style={[appStyles.rowBetween, { width: wp(80), alignSelf: 'center' }]}>
                                            <TouchableOpacity onPress={() => {
                                                // this.takeImage()
                                                this.setState({
                                                    choseImage: true
                                                })
                                            }} style={{
                                                width: 60, height: 60, justifyContent: 'center',
                                                alignItems: 'center', backgroundColor: 'white',
                                                borderRadius: 30
                                            }}>
                                                {this.state.textfield == null || this.state.textfield.length == 0 ? <Image source={icons['camera']} style={{
                                                    width: 30, height: 30, resizeMode: 'contain',
                                                    margin: 10, tintColor: this.state.selectedPerson == null ? blueDarkColor : greenDarkColor
                                                }} /> : <Image source={this.state.textfield} style={{
                                                    width: 60, height: 60, borderRadius: 30, resizeMode: 'contain'
                                                }} />}
                                            </TouchableOpacity>
                                            <TextView style={{ color: 'white' }}>{this.state.needInfo.orderdetails_need[0].topicfield}</TextView>
                                        </View> : <TextInput
                                            label={this.state.needInfo.orderdetails_need[0].topicfield}
                                            labelColor={'white'}
                                            textColor={'white'}
                                            ref={input => { this.inputs['needinfo'] = input }}
                                            returnKeyType={'next'}
                                            onSubmitEditing={() => { this.focusTheField('needinfo', 'name') }}
                                            wrapperStyle={{ width: wp(90) }}
                                            onChangeText={(text) => {
                                                this.setState({
                                                    textfield: text
                                                })
                                            }}
                                            value={this.state.textfield}
                                        />}
                                </View> : null}
                            <TextInput
                                label='نام و نام خانوادگی مددجو(الزامی)'
                                disabled={this.state.selectedPerson != null}
                                labelColor={'white'}
                                textColor={'white'}
                                ref={input => { this.inputs['name'] = input }}
                                returnKeyType={'next'}
                                onSubmitEditing={() => { this.focusTheField('name', 'codemeli') }}
                                wrapperStyle={{ width: wp(90) }}
                                onChangeText={(text) => {
                                    this.setState({
                                        name: text.replace(regexnonenglishdigit, '')
                                    })
                                }}
                                value={this.state.name}
                            />
                            <View style={[appStyles.rowBetween, { width: wp(80), alignSelf: 'center', paddingLeft: 0, paddingRight: 0, paddingTop: 10 }]}>
                                <View style={componentStyles.switchButtonWraper}>

                                    <TouchableOpacity style={this.state.gender == 1 ? componentStyles.activeButton : componentStyles.deactiveButton} onPress={() => {
                                        if (this.state.selectedPerson == null) {
                                            this.setState({
                                                gender: 1
                                            })
                                        }

                                    }}>
                                        <TextView style={this.state.gender == 1 ? componentStyles.activeTextButton : componentStyles.deactiveTextButton}>زن</TextView>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={this.state.gender == 0 ? componentStyles.activeButton : componentStyles.deactiveButton} onPress={() => {
                                        if (this.state.selectedPerson == null) {
                                            this.setState({
                                                gender: 0,
                                            })
                                        }

                                    }}>
                                        <TextView style={this.state.gender == 0 ? componentStyles.activeTextButton : componentStyles.deactiveTextButton}>مرد</TextView>
                                    </TouchableOpacity>
                                </View>
                                <TextView style={{ color: 'white', fontSize: 12 }}>انتخاب جنسیت مددجو</TextView>
                            </View>

                            <TextInput
                                label='کد ملی مددجو(الزامی)'
                                disabled={this.state.selectedPerson != null}
                                labelColor={'white'}
                                textColor={'white'}
                                maxLength={10}
                                inputType='numeric'
                                ref={input => { this.inputs['codemeli'] = input }}
                                returnKeyType={'next'}
                                onSubmitEditing={() => { this.focusTheField('codemeli', 'mobile') }}
                                wrapperStyle={{ width: wp(90) }}
                                onChangeText={(text) => {
                                    this.setState({
                                        code_meli: text
                                    })
                                }}
                                value={this.state.code_meli}
                            />
                            <TextInput
                                label='تلفن همراه'
                                disabled={this.state.selectedPerson != null}
                                labelColor={'white'}
                                textColor={'white'}
                                ref={input => { this.inputs['mobile'] = input }}
                                returnKeyType={'next'}
                                maxLength={13}
                                inputType='numeric'
                                onSubmitEditing={() => { this.focusTheField('mobile', 'phone') }}
                                wrapperStyle={{ width: wp(90) }}
                                onChangeText={(text) => {
                                    this.setState({
                                        mobile: text
                                    })
                                }}
                                value={this.state.mobile}
                            />
                            <TextInput
                                label='شماره ثابت'
                                disabled={this.state.selectedPerson != null}
                                labelColor={'white'}
                                textColor={'white'}
                                ref={input => { this.inputs['phone'] = input }}
                                returnKeyType={'done'}
                                inputType='numeric'
                                wrapperStyle={{ width: wp(90) }}
                                onChangeText={(text) => {
                                    this.setState({
                                        phone: text
                                    })
                                }}
                                value={this.state.phone}
                            />
                            {this.state.needInfo != null && this.state.needInfo.isequipment.includes('yes') ?
                                <View style={[appStyles.rowBetween, { width: wp(90), alignSelf: 'center' }]}>
                                    <View style={componentStyles.switchButtonWraper}>

                                        <TouchableOpacity style={this.state.isequipment == 1 ? componentStyles.activeButton : componentStyles.deactiveButton} onPress={() => {
                                            this.setState({
                                                isequipment: 1,
                                            })
                                        }}>
                                            <TextView style={this.state.isequipment == 1 ? componentStyles.activeTextButton : componentStyles.deactiveTextButton}>بله</TextView>
                                        </TouchableOpacity>
                                        <TouchableOpacity style={this.state.isequipment == 0 ? componentStyles.activeButton : componentStyles.deactiveButton} onPress={() => {
                                            this.setState({
                                                isequipment: 0,
                                            })
                                        }}>
                                            <TextView style={this.state.isequipment == 0 ? componentStyles.activeTextButton : componentStyles.deactiveTextButton}>خیر</TextView>
                                        </TouchableOpacity>
                                    </View>
                                    <TextView style={{ color: 'white', fontSize: 12 }}>آیا تجهیزات مورد نیاز تهیه شود ؟</TextView>
                                </View> : null}


                            {this.state.needInfo != null && this.state.needInfo.rebatecode.includes('yes') ?
                                <TextInput
                                    label='کد تخفیف'
                                    labelColor={'white'}
                                    textColor={'white'}
                                    returnKeyType={'done'}
                                    wrapperStyle={{ width: wp(90) }}
                                    onChangeText={(text) => {
                                        this.setState({
                                            rebateCode: text
                                        })
                                    }}
                                    value={this.state.rebateCode}
                                /> : null}

                        </View>
                        <View style={{ backgroundColor: 'white', padding: 4, borderRadius: 25, marginTop: 20, marginBottom: 50 }}>
                            <Button
                                style={customerLocationStyles.button}
                                text='تایید و ادامه'
                                showArrow={true}
                                textStyle={customerLocationStyles.buttonText}
                                onPress={() => {
                                    if (this.state.needInfo != null && this.state.needInfo.orderdetails_need != null
                                        && this.state.needInfo.orderdetails_need.length > 0) {
                                        if (this.state.textfield != null && this.state.needInfo.orderdetails_need[0].typefield.includes('image') && this.state.textfield.uri != null ||
                                            this.state.textfield != null && this.state.needInfo.orderdetails_need[0].typefield.includes('text') && this.state.textfield.length > 0) {
                                            if (this.state.needInfo != null && this.state.needInfo.isequipment.includes('yes') && this.state.isequipment == 1) {
                                                this.setState({
                                                    showPrompt: true,
                                                    promptMessage: `هزینه تجهیزات در فاکتور جداگانه توسط همکار به شما داده خواهد شد`
                                                })
                                            } else {
                                                this.setState({
                                                    showQuestion: true
                                                })
                                                // this.submitCart()
                                            }
                                        } else {

                                            if (this.state.needInfo.orderdetails_need[0].typefield.includes('image')) {
                                                showMessage('', 'لطفا ' + this.state.needInfo.orderdetails_need[0].topicfield + ' را انتخاب نمایید')
                                            } else {
                                                showMessage('', 'لطفا ' + this.state.needInfo.orderdetails_need[0].topicfield + ' را وارد نمایید')
                                            }
                                        }

                                    } else {
                                        if (this.state.needInfo != null && this.state.needInfo.isequipment.includes('yes') && this.state.isequipment == 1) {
                                            this.setState({
                                                showPrompt: true,
                                                promptMessage: `هزینه تجهیزات در فاکتور جداگانه توسط همکار به شما داده خواهد شد`
                                            })
                                        } else {
                                            this.setState({
                                                showQuestion: true
                                            })
                                            // this.submitCart()
                                        }
                                    }

                                }}
                            />
                        </View>
                    </LinearGradient>


                    <DialogPrompt
                        show={this.state.showPrompt}
                        message={this.state.promptMessage}
                        approve='تایید'
                        cancel='نمیخوام'
                        onApprove={() => {
                            this.setState({
                                showPrompt: false,
                                waiting: true
                            }, () => {
                                this.setState({
                                    showQuestion: true
                                })
                            })

                            // this.submitCart()

                        }}
                        onCancel={() => {
                            this.setState({
                                showPrompt: false
                            })

                        }}
                        onClose={() => {
                            this.setState({
                                showPrompt: false
                            })
                        }} />
                    <Waiting waiting={this.state.waiting} />
                    <BottomModal show={this.state.choseImage} onClose={() => {
                        this.setState({
                            choseImage: false
                        })
                    }}>
                        <View>
                            <View style={[appStyles.row, { marginTop: 20, marginBottom: 20 }]}>

                                <TextView style={appStyles.bottomModalTitle}>لطفا از نسخه بطور کامل عکس بگیرید</TextView>
                                <TouchableOpacity style={appStyles.row} onPress={() => {
                                    this.setState({
                                        choseImage: false
                                    })
                                }}>
                                    <Image source={icons['back']} style={appStyles.backImage} />
                                </TouchableOpacity>
                            </View>
                            <View style={[appStyles.row, { marginTop: 20, marginBottom: 20, justifyContent: 'space-around' }]}>
                                <TouchableOpacity style={componentStyles.choseButton} onPress={() => {
                                    this.setState({
                                        choseImage: false
                                    }, () => {
                                        this.takeImage()
                                    })
                                }}>
                                    <Image source={icons['take_photo']} style={{ width: 60, height: 60, resizeMode: 'contain' }} />
                                    <TextView>دوربین</TextView>
                                </TouchableOpacity>
                                <TouchableOpacity style={componentStyles.choseButton} onPress={() => {
                                    this.setState({
                                        choseImage: false
                                    }, () => {
                                        this.pickImage()
                                    })
                                }}>
                                    <Image source={icons['gallery']} style={{ width: 60, height: 60, resizeMode: 'contain' }} />
                                    <TextView>گالری</TextView>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </BottomModal>
                    <DialogFavExper
                        sex={this.state.gender == 0 ? 'male' : 'female'}
                        show={this.state.showQuestion}
                        onClose={() => {
                            this.setState({
                                showQuestion: false
                            })
                        }}
                        onNearExpert={() => {
                            this.setState({
                                selectedExpert: null,
                                showQuestion: false
                            }, () => {
                                this.submitCart()
                            })

                        }}
                        onFavExpert={(id) => {
                            this.setState({
                                selectedExpert: id,
                                showQuestion: false
                            }, () => {
                                this.submitCart()
                            })
                        }}
                    />
                </View>
            </ScrollView>
        )
    }
    submitCart() {
        this.setState({
            waiting: true
        })
        if (this.state.selectedPerson != null) {
            completeOrderRequest(this.state.selectedPerson.id, '', '', '', '', '', this.state.isequipment === 1 ? 'yes' : 'no', this.state.bime,
                this.state.rebateCode, this.state.textfield, this.state.selectedExpert, (isConnect, response) => {
                    this.setState({
                        waiting: false
                    })
                    if (isConnect && response.isSuccess) {
                        if (response.data.msg != null && response.data.msg.length > 0) {
                            showMessageCallback('', response.data.msg, () => {
                                this.props.navigation.popToTop();
                                this.props.navigation.navigate('requestInfo', {
                                     id: response.data.idorder,
                                    onRefresh: () => {

                                    }
                                })
                            })
                        } else {
                            this.props.navigation.popToTop();
                            this.props.navigation.navigate('requestInfo', {
                                 id: response.data.idorder ,
                                onRefresh: () => {

                                }
                            })
                        }

                    } else {
                        showMessage('', getError(response))
                    }
                })
        } else {
            completeOrderRequest('', this.state.name, this.state.gender == 0 ? 'male' : 'female', this.state.phone,
                this.state.code_meli, this.state.mobile, this.state.isequipment == 1 ? 'yes' : 'no', this.state.bime,
                this.state.rebateCode, this.state.textfield, this.state.selectedExpert, (isConnect, response) => {
                    this.setState({
                        waiting: false
                    })
                    if (isConnect && response.isSuccess) {
                        if (response.data.msg != null && response.data.msg.length > 0) {
                            showMessageCallback('', response.data.msg, () => {
                                this.props.navigation.popToTop();
                                this.props.navigation.navigate('requestInfo', {
                                     id: response.data.idorder ,
                                    onRefresh: () => {

                                    }
                                })
                            })
                        } else {
                            this.props.navigation.popToTop();
                            this.props.navigation.navigate('requestInfo', {
                               id: response.data.idorder ,
                                onRefresh: () => {

                                }
                            })
                        }
                    } else {
                        showMessage('', getError(response))
                    }
                })
        }
    }

    componentWillMount() {
        favoritPersonsRequest((isConnect, response) => {
            if (isConnect && response.isSuccess) {
                this.setState({
                    favorits: response.data
                })
            }
        })
        getNeedInfoRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    needInfo: response.data.needinfo
                })
            }
        })
    }
}
